import { getAllStories } from "@cinch-nx/data-storyblok";
export const getStaticProps = async ({ preview =false  })=>{
    try {
        const { stories  } = await getAllStories({
            starts_with: "jargon",
            version: preview ? "draft" : "published"
        });
        const customStories = stories.map((story)=>({
                content: {
                    question: story.content.question,
                    summary: story.content.summary,
                    fullTerm: story.content.fullTerm,
                    keywords: story.content.keywords
                },
                slug: story.slug
            }));
        return {
            props: {
                stories: customStories,
                preview,
                layoutProps: {
                    showBorderRadius: true
                }
            },
            revalidate: 60
        };
    } catch  {
        return {
            notFound: true,
            props: {
                stories: [],
                preview,
                layoutProps: {
                    showBorderRadius: true
                }
            },
            revalidate: 60
        };
    }
};
